import { SuspenseBusy, withSuspense } from '@tunasong/ui-lib'
import React from 'react'
import type { FC } from 'react'
import { AdminGuard } from './auth/admin-guard.js'
import { pageChrome } from './page-chrome.js'

/** The admin status page: its own chunk, from `@tunasong/tunasong-ui/admin`, loaded only for an admin (spec §3.4) */
const LazyAdminStatusPage = withSuspense(
  React.lazy(async () => {
    const { AdminStatusPage } = await import('@tunasong/tunasong-ui/admin')
    return { default: AdminStatusPage }
  }),
  <SuspenseBusy />
)

const AdminStatusInChrome = pageChrome(LazyAdminStatusPage, { container: true })

/** Outside the chrome, so a non-admin gets the catch-all's Not found, not one inside the app's chrome */
export const AdminRoute: FC = () => (
  <AdminGuard>
    <AdminStatusInChrome />
  </AdminGuard>
)
